export enum SidebarViewer {
  viewerMedianZones = 'viewer-median-zones',
  viewerMedianZonePolygons = 'viewer-median-zones-polygons',
  viewerIntersections = 'viewer-intersections',
}
